import { render, staticRenderFns } from "./GrnUpdatedetail.vue?vue&type=template&id=2df693ae&scoped=true"
import script from "./GrnUpdatedetail.vue?vue&type=script&lang=js"
export * from "./GrnUpdatedetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df693ae",
  null
  
)

export default component.exports